/* Generated from contract/schemas; do not edit (pnpm gen). */
import type { Agent } from "./types/agent.d.ts";
import type { Connection } from "./types/connection.d.ts";
import type { Dataset } from "./types/dataset.d.ts";
import type { Environment } from "./types/environment.d.ts";
import type { EvalSuite } from "./types/eval-suite.d.ts";
import type { KnowledgeBase } from "./types/knowledge-base.d.ts";
import type { McpServer } from "./types/mcp-server.d.ts";
import type { Model } from "./types/model.d.ts";
import type { Orchestration } from "./types/orchestration.d.ts";
import type { Project } from "./types/project.d.ts";
import type { Prompt } from "./types/prompt.d.ts";
import type { Retriever } from "./types/retriever.d.ts";
import type { Schedule } from "./types/schedule.d.ts";
import type { Skill } from "./types/skill.d.ts";
import type { Team } from "./types/team.d.ts";
import type { Workspace } from "./types/workspace.d.ts";

/** Kind name as written in a spec, keyed by the schema file slug. */
export const KINDS = {
  "agent": "Agent",
  "connection": "Connection",
  "dataset": "Dataset",
  "environment": "Environment",
  "eval-suite": "EvalSuite",
  "knowledge-base": "KnowledgeBase",
  "mcp-server": "McpServer",
  "model": "Model",
  "orchestration": "Orchestration",
  "project": "Project",
  "prompt": "Prompt",
  "retriever": "Retriever",
  "schedule": "Schedule",
  "skill": "Skill",
  "team": "Team",
  "workspace": "Workspace",
} as const;

export type KindSlug = keyof typeof KINDS;
export type Kind = (typeof KINDS)[KindSlug];

/** The spec document type of each kind. */
export interface SpecByKind {
  "Agent": Agent;
  "Connection": Connection;
  "Dataset": Dataset;
  "Environment": Environment;
  "EvalSuite": EvalSuite;
  "KnowledgeBase": KnowledgeBase;
  "McpServer": McpServer;
  "Model": Model;
  "Orchestration": Orchestration;
  "Project": Project;
  "Prompt": Prompt;
  "Retriever": Retriever;
  "Schedule": Schedule;
  "Skill": Skill;
  "Team": Team;
  "Workspace": Workspace;
}
